import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { CargaPrioritariaHibrido } from "src/store/vendas/projetos/hibrido/hibrido.types"

export const calcularPotenciaEquipamentosHibrido = (cargasPrioritarias: CargaPrioritariaHibrido[]): { total_va: number, total_kva: number } => {
  const total = cargasPrioritarias?.filter(e => !e["@remove"])?.reduce((acc, curr) => {
    const potenciaNominalVa = (curr.potencia / curr.fator_potencia) * curr.quantidade;
    const potenciaPicoVa = potenciaNominalVa * curr.relacao_partida;
    return acc + potenciaPicoVa
  }, 0)

  return { total_va: total, total_kva: total > 0 ? DecimalUtil.toFixed(total / 1000, 2) : 0 }
}